import { Button } from '@quadminds/mindkit';
import { useTranslation } from 'react-i18next';

const KNOWLEDGE_VIDEO_URL = 'https://www.youtube.com/embed/JHwbKVBU5W8';

interface KnowledgeVideoSlideProps {
    readonly onComplete: () => void;
}

export const KnowledgeVideoSlide = ({ onComplete }: KnowledgeVideoSlideProps) => {
    const { t } = useTranslation();

    return (
        <div className="p-8 flex flex-col flex-grow gap-6 text-center">
            <div className="flex flex-col gap-2">
                <h2 className="text-2xl font-poppins font-semibold text-foreground">{t('onboarding.video.title')}</h2>
                <p className="text-muted-foreground">{t('onboarding.video.description')}</p>
            </div>

            <div className="w-full aspect-video overflow-hidden rounded-lg bg-black">
                <iframe
                    className="h-full w-full"
                    src={KNOWLEDGE_VIDEO_URL}
                    title={t('onboarding.video.title')}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            </div>

            <Button onClick={onComplete} className="w-full">
                {t('onboarding.video.cta')}
            </Button>
        </div>
    );
};
